import {
  hasMarketplacePluginContract,
  hasMarketplacePluginBridgeShape,
  supportsPluginArtifactMutationResponse,
} from '../../app/runtime/pluginCompatibility';

export const supportsPluginArtifactMutationSnapshot = supportsPluginArtifactMutationResponse;
export const supportsMarketplacePluginBridgeShape = hasMarketplacePluginBridgeShape;

/**
 * Read the plugin's current mutation contract independently of the shell's
 * bootstrap snapshot. Explicit current capabilities and the verified 1.0.4+
 * marketplace contract are accepted; unknown/disconnected responses fail closed.
 */
export async function readLiveArtifactMutationCapability(bridgeClient) {
  if (!bridgeClient || typeof bridgeClient.sendMessageWithResponse !== 'function') {
    return false;
  }

  try {
    const onboarding = await bridgeClient.sendMessageWithResponse('onboarding.state', {});
    if (onboarding?.result !== 'error' && supportsPluginArtifactMutationResponse(onboarding)) {
      return true;
    }

    // Marketplace 1.0.4-1.0.7 onboarding.state exposes the publication
    // capability triad but not the module version. Its old app.bootstrap also
    // reports a hard-coded 1.0.0, while gateway.identity.get is the canonical
    // source and contains the real module version.
    const identityResponse = await bridgeClient.sendMessageWithResponse('gateway.identity.get', {});
    const identity = identityResponse?.identity || identityResponse?.data?.identity || {};
    const onboardingState = onboarding?.state || onboarding || {};
    if (identityResponse?.result !== 'error' && hasMarketplacePluginContract({
      platform: identity.platform,
      moduleVersion: identity.moduleVersion || identity.module_version,
      capabilities: onboardingState.capabilities || {},
    })) {
      return true;
    }

    const bootstrap = await bridgeClient.sendMessageWithResponse('app.bootstrap', {});
    return bootstrap?.result !== 'error' && supportsPluginArtifactMutationResponse(bootstrap);
  } catch (_error) {
    return false;
  }
}
